export default __webpack_public_path__ + "static/media/expandIcon.75446a6a.svg";